import api from "../api/configAxios";
import Controller from "../common/controller";

export const getAllSponsors = async () => {
  try {
    var response = await api.get(`${Controller.Sponsor}/sponsorAccountList`);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};



export const getSponsorAnalytics = async (placementIds, accessToken) => {
  try {
    // Log the placement IDs being sent to the API
    console.log("Sending Placement IDs to the API:", placementIds);

    // Make the POST request to send the placement IDs to the backend
    const response = await api.post(`${Controller.Sponsor}/getAnalytics`, placementIds, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    // Log the response from the backend
    console.log("Analytics Data Response:", response.data);

    // Return the response data for further use
    return response.data;
  } catch (error) {
    // Handle the error if the request fails
    console.error("Error in API call to get analytics data:", error);
    throw new Error("Failed to fetch analytics data");
  }
};


export const downloadSummaryReport = async (
  { email, isScheduled, startDate, endDate, recurrence, scheduleDate, scheduleTime, reportType },
  accessToken
) => {
  const body = {
    Email: email,
    IsScheduled: isScheduled,
    StartDate: startDate,   // "2025-07-24"
    EndDate: endDate,       // "2025-07-24"
    Recurrence: recurrence,
    ScheduledTime: isScheduled
      ? `${scheduleDate}T${scheduleTime}:00.000000`
      : null,
    ReportType: reportType,  // e.g., "Summary"
  };

  const url = `${Controller.Sponsor}/DashboardReport`;

  // Make the POST request and handle binary data response
  const response = await api.post(url, body, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    responseType: 'blob', // Important for binary data (e.g., PDF)
  });

  return response.data;  // this will return the PDF file as a Blob
};





export const DownloadAccountList = async (
  { email, isScheduled, startDate, endDate, scheduleDate,recurrence, scheduleTime, reportType },
  accessToken
) => {
  const body = {
    Email: email,
    IsScheduled: isScheduled,
    StartDate: startDate,
    EndDate: endDate,
    Recurrence:recurrence,
    ScheduledTime: isScheduled
      ? `${scheduleDate}T${scheduleTime}:00.000000`
      : null,
    ReportType: reportType,
  };

  const url = `${Controller.Sponsor}/SponsorAccountListReport`;

  // Make sure Axios does NOT try to parse JSON, use blob for binary data
  const response = await api.post(url, body, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    responseType: 'blob',   // <- key to handle binary data
  });

  return response.data;  // returns the binary data as a Blob
};

// New endpoint to download Sponsor Analytics Report
export const downloadSponsorAnalyticReport = async (
  { email, isScheduled, startDate, endDate, recurrence, scheduleDate, scheduleTime, sponsorId },
  accessToken
) => {
  const body = {
    Email: email,
    IsScheduled: isScheduled,
    StartDate: startDate,
    EndDate: endDate,
    Recurrence: recurrence,
    ScheduledTime: isScheduled ? `${scheduleDate}T${scheduleTime}:00.000000` : null,
    SponsorId: sponsorId // Added SponsorId to the request body
  };
  
  console.log("Sending sponsorId to backend:", sponsorId);
  
  const url = `${Controller.Sponsor}/SponsorAnalyticReport`;
  const response = await api.post(url, body, {
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'blob',
  });
  return response.data;
};



export const getSponsorsDashboardData = async () => {
  try {
    var response = await api.get(`${Controller.Sponsor}/SponsorDashboard`);
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
};

// export const getSponsorData = async (dynamoDBClient, sponsorId) => {
//   try {
//     let params = {
//       TableName: "SponsorInteractions",
//       IndexName: "SponsorId-index",
//       KeyConditionExpression: "SponsorId = :sponsorId",
//       ExpressionAttributeValues: {
//         ":sponsorId": sponsorId,
//       },
//     };

//     let allItems = [];
//     let lastEvaluatedKey = null;

//     do {
//       if (lastEvaluatedKey) {
//         params.ExclusiveStartKey = lastEvaluatedKey;
//       }
//       const response = await dynamoDBClient.query(params).promise();
//       allItems = allItems.concat(response.Items || []);
//       lastEvaluatedKey = response.LastEvaluatedKey;
//     } while (lastEvaluatedKey);

//     return { Items: allItems };
//   } catch (error) {
//     throw new Error(error);
//   }
// };

export const deleteSponsor = async (id) => {
  try {
    var response = await api.patch(`${Controller.Sponsor}/${id}/disable`);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getSponsorConfigurationData = async (dynamoDBClient) => {
  try {
    const params = {
      TableName: "Configurations",
      FilterExpression: "ModeType = :id",
      ExpressionAttributeValues: {
        ":id": "SponsorConfiguration",
      },
    };
    const data = await dynamoDBClient.scan(params).promise();

    return data.Items;
  } catch (error) {
    throw new Error(error);
  }
};

export const getSponsorCount = async (dynamoDBClient) => {
  try {
    const params = {
      TableName: "Sponsors",
      Select: "COUNT",
    };
    const response = await dynamoDBClient.scan(params).promise();

    return response;
  } catch (error) {
    throw new Error(error);
  }
};



